import { getNewClassOfService } from './classOfService';

export const isExistingTrain =
  (existingTrain, outboundDate, trainNumbers) =>
  ({ legs } = { legs: [] }, classOfService) => {
    const newTrainNumbers = legs.map((leg) => leg.trainNumber);

    return (
      existingTrain &&
      existingTrain.date === outboundDate &&
      trainNumbers.every((number) => newTrainNumbers.includes(number)) &&
      getNewClassOfService(existingTrain?.classOfService?.code) === getNewClassOfService(classOfService)
    );
  };
